var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgSubstituteAuthorizedPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 92,
    viewBox: "0 0 112 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5971 40.5047C18.1467 40.5584 18.5489 41.0474 18.4952 41.5971C18.1771 44.8585 18.7126 49.6841 21.2833 53.5598C23.5281 56.944 27.3951 59.7142 33.9226 60.0084L29.1678 55.6859C28.7592 55.3144 28.7291 54.6819 29.1006 54.2733C29.4721 53.8646 30.1045 53.8345 30.5132 54.206L37.1726 60.2601C37.5813 60.6316 37.6114 61.264 37.2399 61.6727L31.1859 68.3321C30.8143 68.7408 30.1819 68.7709 29.7732 68.3994C29.3646 68.0279 29.3345 67.3955 29.706 66.9868L34.2206 62.0207C26.877 61.7937 22.2906 58.6966 19.6166 54.6653C16.7207 50.2992 16.1562 44.9749 16.5047 41.4029C16.5583 40.8532 17.0474 40.4511 17.5971 40.5047Z",
    fill: "#539674"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5C0 28.7173 8.28273 37 18.5 37Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13074_22118",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 33,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5002 33.8571C27.2579 33.8571 34.3574 26.7577 34.3574 18C34.3574 9.24234 27.2579 2.14285 18.5002 2.14285C9.74255 2.14285 2.64307 9.24234 2.64307 18C2.64307 26.7577 9.74255 33.8571 18.5002 33.8571Z",
    fill: "#EDF5F1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13074_22118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8304 16.9107C21.5671 16.9107 23.7857 14.6921 23.7857 11.9554C23.7857 9.21859 21.5671 7 18.8304 7C16.0936 7 13.875 9.21859 13.875 11.9554C13.875 14.6921 16.0936 16.9107 18.8304 16.9107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5002 40.4643C24.7036 40.4643 29.7324 35.4355 29.7324 29.2321C29.7324 23.0288 24.7036 18 18.5002 18C12.2969 18 7.26807 23.0288 7.26807 29.2321C7.26807 35.4355 12.2969 40.4643 18.5002 40.4643Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75 92C93.2254 92 108 77.2254 108 59C108 40.7746 93.2254 26 75 26C56.7746 26 42 40.7746 42 59C42 77.2254 56.7746 92 75 92Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13074_22118",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 29,
    width: 58,
    height: 58
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0001 86.3938C90.6218 86.3938 103.286 73.7299 103.286 58.1081C103.286 42.4863 90.6218 29.8224 75.0001 29.8224C59.3783 29.8224 46.7144 42.4863 46.7144 58.1081C46.7144 73.7299 59.3783 86.3938 75.0001 86.3938Z",
    fill: "#EDF5F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13074_22118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5888 56.9295C80.4706 56.9295 84.4281 52.9721 84.4281 48.0903C84.4281 43.2085 80.4706 39.251 75.5888 39.251C70.707 39.251 66.7495 43.2085 66.7495 48.0903C66.7495 52.9721 70.707 56.9295 75.5888 56.9295Z",
    fill: "#3D83BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0001 98.1795C86.0655 98.1795 95.0358 89.2092 95.0358 78.1438C95.0358 67.0784 86.0655 58.1081 75.0001 58.1081C63.9346 58.1081 54.9644 67.0784 54.9644 78.1438C54.9644 89.2092 63.9346 98.1795 75.0001 98.1795Z",
    fill: "#3D83BB"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112 36.5C112 42.299 107.299 47 101.5 47C95.701 47 91 42.299 91 36.5C91 30.701 95.701 26 101.5 26C107.299 26 112 30.701 112 36.5Z",
    fill: "#1E5D8F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.723 35.123H102.877V32.277C102.877 31.5161 102.261 30.9 101.5 30.9C100.739 30.9 100.123 31.5161 100.123 32.277V35.123H97.2769C96.5167 35.123 95.8999 35.7391 95.8999 36.5C95.8999 37.2602 96.5167 37.877 97.2769 37.877H100.123V40.7223C100.123 41.4832 100.739 42.1 101.5 42.1C102.261 42.1 102.877 41.4832 102.877 40.7223V37.8763H105.723C106.483 37.8763 107.1 37.2602 107.1 36.4993C107.1 35.7391 106.483 35.123 105.723 35.123Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSubstituteAuthorizedPerson);
export default __webpack_public_path__ + "static/media/imgSubstituteAuthorizedPerson.65cda87a44b018412897fb8ef27f0a0b.svg";
export { ForwardRef as ReactComponent };